var React = require('react');

function TranscriptInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 12.7038V4.3125C17 3.76022 16.5523 3.3125 16 3.3125H2C1.44772 3.3125 1 3.76022 1 4.3125V13.3125C1 13.8648 1.44772 14.3125 2 14.3125H13.5858C13.851 14.3125 14.1054 14.4179 14.2929 14.6054L16 16.3125","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M4 6.3125H14","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M4 8.8125H14","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M4 11.3125H10","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","key":3})]);
}

TranscriptInline.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = TranscriptInline;

TranscriptInline.default = TranscriptInline;
